import NotAuthorizedError from '@/api/custom-errors.js';

// ---
// обработчик ошибок ответа (случаев, когда http-код не 2xx)
//   может зависеть от апи и меняться от проекта к проекту, хотя и есть надежды на унификацию для какого-то базового сценария
// в ф-ции можно отдельно рассмотреть ошибки http и при необходимости трансформировать их в логические ошибки
// ---

export function handleHttpResponseError (error) {
  switch (error.response.status) {
    case 401: {
      error = new NotAuthorizedError('Для входа в личный кабинет Вам необходимо авторизоваться.');
      break;
    }
    case 403: {
      error.message = 'Доступ запрещён';
      break;
    }
    case 404: {
      error.message = 'Адрес не найден';
      break;
    }
  }
  throw error;
}
